import React, { useState, useEffect } from 'react';

// third-party
import { IntlProvider, MessageFormatElement } from 'react-intl';
import useConfig from 'hooks/useConfig';

// load locales files
const loadLocaleData = (locale: string) => {
    switch (locale) {
        case 'en':
            return import('utils/locales/en.json');
        case 'pt':
            return import('utils/locales/pt.json');
        case 'es':
        default:
            return import('utils/locales/es.json');
    }
};

// ==============================|| LOCALIZATION ||============================== //

interface LocalsProps {
    children: React.ReactNode;
}

const Locales = ({ children }: LocalsProps) => {
    const { locale } = useConfig();
    const [messages, setMessages] = useState<Record<string, string> | Record<string, MessageFormatElement[]> | undefined>();

    var navlocale = 'es';
    if (navigator.language === 'en') {
        navlocale = 'en';
    }

    useEffect(() => {
        console.log('locale', locale);
        loadLocaleData(locale).then((d) => {
            try {
                const localeData = d.default as any;
                setMessages(localeData);

                // Update meta description based on language
                const metaDescription = document.querySelector('meta[name="description"]');
                if (metaDescription && localeData?.landing?.meta_description) {
                    metaDescription.setAttribute('content', localeData.landing.meta_description);
                }
            } catch (error) {
                console.error('Error loading locale data:', error);
                setMessages({});
            }
        });
    }, [locale]);

    return (
        <>
            {messages && (
                <IntlProvider locale={locale} defaultLocale={navlocale} messages={messages}>
                    {children}
                </IntlProvider>
            )}
        </>
    );
};

export default Locales;
